import { render, staticRenderFns } from "./CheckGroup.vue?vue&type=template&id=52239f44&"
import script from "./CheckGroup.vue?vue&type=script&lang=js&"
export * from "./CheckGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports